<script setup>
import debugStorage from '@/services/debugStorage'
import { ref } from 'vue';


const open = ref(false);
const items = debugStorage.items;
const toggle = () => open.value = !open.value;
const reload = debugStorage.load;
const remove = (traceId) => debugStorage.remove(`request-${traceId}`);
const clearAll = () => {
    debugStorage.clearAll();
    open.value = false;
}

const copy = async (text) => {
    await navigator.clipboard.writeText(text);
}
</script>

<template>
    <!-- FAB -->
    <div class="fab" @click="toggle" v-if="items.length > 0">
        🐞
        <span v-if="items.length" class="badge">{{ items.length }}</span>
    </div>

    <!-- Drawer -->
    <transition name="slide">
        <div v-if="open" class="drawer">
            <div class="header">
                <strong>Request Debug</strong>
                <div class="actions">
                    <button @click="reload">↻</button>
                    <button @click="clearAll">🗑</button>
                    <button @click="toggle">✕</button>
                </div>
            </div>

            <div v-if="items.length === 0" class="empty">
                No errors logged
            </div>

            <div
                v-for="item in items"
                :key="item.traceId"
                class="card"
            >
                <div class="row">
                    <span class="label">TraceId</span> -
                    <code @click="copy(item.traceId)">{{ item.traceId }}</code>
                </div>

                <div class="row">
                    <span class="label">SpanId</span> -
                    <code @click="copy(item.spanId)">{{ item.spanId }}</code>
                </div>

                <div class="row">
                    <span class="label">URL</span>
                    <div class="url">{{ item.requestedUrl }}</div>
                </div>

                <div class="row">
                    <span class="label">Status</span> -
                    <span :class="['status', item.responseStatus >= 500 ? 'err' : 'warn']">
            {{ item.responseStatus }}
          </span>
                </div>

                <pre v-if="item.responseError">{{ item.responseError }}</pre>

                <button class="remove" @click="remove(item.traceId)">
                    Remove
                </button>
            </div>
        </div>
    </transition>
</template>


<style scoped>
.fab {
    position: fixed;
    right: 16px;
    bottom: 50px;
    width: 44px;
    height: 44px;
    background: #111;
    color: #fff;
    border-radius: 50%;
    display: grid;
    place-items: center;
    cursor: pointer;
    font-size: 20px;
    z-index: 9998;
}

.badge {
    position: absolute;
    top: -6px;
    right: -6px;
    background: #dc2626;
    color: #fff;
    font-size: 10px;
    border-radius: 999px;
    padding: 2px 6px;
}

.drawer {
    position: fixed;
    right: 0;
    bottom: 0;
    width: 420px;
    max-height: 80vh;
    background: #0f0f0f;
    color: #eee;
    z-index: 9999;
    border-top-left-radius: 12px;
    padding: 12px;
    overflow: auto;
}

.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.actions button {
    margin-left: 4px;
}

.card {
    background: #1a1a1a;
    border-radius: 8px;
    padding: 8px;
    margin-bottom: 8px;
}

.row {
    margin-bottom: 4px;
}

.label {
    opacity: 0.6;
    font-size: 11px;
}

.url {
    word-break: break-all;
    font-size: 12px;
}

.status.err {
    color: #f87171;
}
.status.warn {
    color: #fbbf24;
}

pre {
    background: #000;
    padding: 6px;
    border-radius: 6px;
    font-size: 11px;
    overflow: auto;
}

.remove {
    margin-top: 6px;
}

.slide-enter-active,
.slide-leave-active {
    transition: transform 0.2s ease;
}

.slide-enter-from,
.slide-leave-to {
    transform: translateY(100%);
}
</style>
